import {
    getVocabularySoundList,
    getAudioFileNameSoundList
} from '@/plugin/getSoundList'
export default {
    watch: {
        lessonExam(val) {
            if (val) {
                this.wordSound.urlList = getVocabularySoundList(val)
            }
        },
        todayList(val) {
            if (val) {
                this.wordSound.urlList = getAudioFileNameSoundList(val)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/controller/vocabularySoundConrtoller.js